import React, { useEffect, useState } from 'react'
import { ArrayTotalizarByProp } from '../../Actions/TotalizarProps';
import { FormatMoney } from '../../../../Helpers/FormatNumber';
import { Nivel3Screen } from './Nivel3Screen';

export const Nivel2Screen = ({ data, nivel1, group }) => {
    const [state, setState] = useState([]);
    const [nivel2, setNivel2] = useState([]);
    const [totales, setTotales] = useState({
        total: 0,
        totalanterior: 0,
        variacion: 0
    })
    useEffect(() => {
        if (data === undefined || data == null || data.lenght === 0) {
            setState([]);
            return;
        }

        var arrayfilter = data.filter(x => x.nivel1 === nivel1);
        setNivel2(arrayfilter);
        var array = arrayfilter.reduce(function (groups, item) {
            var val = item['nivel2']
            groups[val] = groups[val] || val;
            return groups;
        }, {});
        setState(Object.values(array));
    }, [data])
    useEffect(() => {
        setTotales({
            total: ArrayTotalizarByProp(nivel2, "total"),
            totalanterior: ArrayTotalizarByProp(nivel2, 'totalanterior'),
            variacion: ArrayTotalizarByProp(nivel2, 'variacion')
        })
    }, [nivel2])
    if (state.length == 0) return <div></div>

    const capitalizeWords = (str) => {
        return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
      }; 

    return (
        <>
            {
                state.map(item => (
                    <>
                        <tr>
                            <td colSpan={9} className='nivel2'>{capitalizeWords(item)}</td>
                        </tr>
                        <tr className='tr-espacion-5'></tr>
                        <Nivel3Screen data={nivel2}
                            nivel2={item}
                            group={item}
                            n1total={totales.total}
                            n1totalanterior={totales.totalanterior}
                        />
                        <tr className='tr-espacion-3'></tr>

                    </>
                ))
            }
            <tr className='total-grupo'>
                <td colSpan={3}>TOTAL {group}</td>
                <td className='importe ta-right'>{FormatMoney(totales.total,0)}</td>
                <td className='importe ta-right'>100</td>
                <td className='importe ta-right'>{FormatMoney(totales.totalanterior,0)}</td>
                <td className='importe ta-right'>100</td>
                <td className={`importe ${totales.variacion < 0 ? 'fcolor-red' : ''} ta-right`}>{FormatMoney(totales.variacion,0)}</td>
                <td className={`importe ${totales.variacion < 0 ? 'fcolor-red' : ''} ta-right`}>{FormatMoney(totales.variacion/totales.totalanterior*100,1)}</td>
            </tr>
            <tr className='tr-espacion-2'></tr>
        </>
    )
}
